import { NgModule } from '@angular/core';
import { OverlayScrollbarsComponent } from './overlayscrollbars.component';
var OverlayscrollbarsModule = (function () {
    function OverlayscrollbarsModule() {
    }
    OverlayscrollbarsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [],
                    declarations: [OverlayScrollbarsComponent],
                    exports: [OverlayScrollbarsComponent]
                },] },
    ];
    return OverlayscrollbarsModule;
}());
export { OverlayscrollbarsModule };
//# sourceMappingURL=overlayscrollbars.module.js.map